
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { secureOpenUrl } from '@/utils/linkValidation';

interface HeaderActionsProps {
  onScheduleClick: () => void;
}

const HeaderActions = ({ onScheduleClick }: HeaderActionsProps) => {
  const [hoveredLogin, setHoveredLogin] = useState(false);

  const handleScheduleClick = () => {
    window.open('https://tidycal.com/nexx-telecom/30-minute-meeting-m72ke5v', '_blank');
  };

  const handleLoginClick = () => {
    secureOpenUrl('https://acc.nexx.net/clientarea.php');
  };

  return (
    <div className="hidden lg:flex items-center space-x-4">
      <Button 
        variant="outline" 
        className="border-nexx-green text-nexx-green hover:bg-nexx-green hover:text-white"
        onClick={handleScheduleClick}
      >
        Schedule Meeting
      </Button>
      <div className="relative">
        <Button 
          variant="ghost" 
          className="text-gray-600 hover:text-nexx-green hover:shadow-lg hover:shadow-green-500/25 hover:bg-green-50 transition-all duration-200"
          onMouseEnter={() => setHoveredLogin(true)}
          onMouseLeave={() => setHoveredLogin(false)}
          onClick={handleLoginClick}
        >
          Login
        </Button>
        <div className={`absolute -bottom-6 left-1/2 transform -translate-x-1/2 transition-opacity duration-200 pointer-events-none z-50 ${hoveredLogin ? 'opacity-100' : 'opacity-0'}`}>
          <div className="bg-nexx-green text-white px-2 py-1 rounded text-xs whitespace-nowrap">
            Billing Platform
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderActions;
